import { Tab, TabsGroup } from '@billy/design-system'
import { ReactElement, ReactNode, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useLocalStorageUncontrolled } from '../../../../hooks/useLocalStorageUncontrolled'
import { getOrganizationViewUrl } from '../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { SALES_REPORT_ROUTE_STORAGE_KEY } from '../../constants/salesReportRouteStorageKey'
import * as Styled from './styles'

interface NavigationTabs {
  name: ReactNode
  route: string
}

export const SalesReportNavigationTabs = (): ReactElement | null => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const location = useLocation()

  const { setItem } = useLocalStorageUncontrolled(SALES_REPORT_ROUTE_STORAGE_KEY)

  useEffect(() => {
    setItem(location.pathname)
  }, [location.pathname, setItem])

  const navigationTabs: NavigationTabs[] = useMemo(
    () => [
      {
        name: t('sales_report.sales_overview'),
        route: getOrganizationViewUrl(organization?.url, reactRoute.organization.salesReport.getSalesOverviewRoute()),
      },
      {
        name: t('sales_report.sales_by_item'),
        route: getOrganizationViewUrl(organization?.url, reactRoute.organization.salesReport.getSalesByItemRoute()),
      },
      {
        name: t('sales_report.sales_by_customer'),
        route: getOrganizationViewUrl(organization?.url, reactRoute.organization.salesReport.getSalesByCustomerRoute()),
      },
    ],
    [t, organization?.url],
  )

  if (!organization) {
    return null
  }

  return (
    <Styled.SalesReportNavigationTabsWrapper>
      <TabsGroup>
        {navigationTabs.map(({ name, route }) => (
          <Tab key={route} active={location.pathname.includes(route)} to={`${route}${location.search}`}>
            {name}
          </Tab>
        ))}
      </TabsGroup>
    </Styled.SalesReportNavigationTabsWrapper>
  )
}
